// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Typography base styles */
.typography {
  font-family: 'Urbanist', sans-serif;
  margin: 0;
  padding: 0;
}

/* Desktop typography variants */
.typography-h1 {
  font-size: 32px;
  font-weight: 600;
  line-height: 48px;
}

.typography-h2 {
  font-size: 24px;
  font-weight: 600;
  line-height: 36px;
}

.typography-h3 {
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
}

.typography-body-bold {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

.typography-body {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.typography-body-small-bold {
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
}

.typography-body-small {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
}

/* Mobile typography variants */
@media (max-width: 768px) {
  .typography-h1 {
    font-size: 24px;
    line-height: 32px;
  }

  .typography-h2 {
    font-size: 18px;
    line-height: 24px;
  }

  .typography-h3 {
    font-size: 16px;
    line-height: 24px;
  }

  .typography-body-bold {
    font-size: 14px;
    line-height: 21px;
  }

  .typography-body {
    font-size: 14px;
    line-height: 21px;
  }

  .typography-body-small-bold {
    font-size: 12px;
    line-height: 18px;
  }

  .typography-body-small {
    font-size: 12px;
    line-height: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Text/Typography.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,mCAAmC;EACnC,SAAS;EACT,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,+BAA+B;AAC/B;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["/* Typography base styles */\n.typography {\n  font-family: 'Urbanist', sans-serif;\n  margin: 0;\n  padding: 0;\n}\n\n/* Desktop typography variants */\n.typography-h1 {\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 48px;\n}\n\n.typography-h2 {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 36px;\n}\n\n.typography-h3 {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n}\n\n.typography-body-bold {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.typography-body {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.typography-body-small-bold {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 21px;\n}\n\n.typography-body-small {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 21px;\n}\n\n/* Mobile typography variants */\n@media (max-width: 768px) {\n  .typography-h1 {\n    font-size: 24px;\n    line-height: 32px;\n  }\n\n  .typography-h2 {\n    font-size: 18px;\n    line-height: 24px;\n  }\n\n  .typography-h3 {\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  .typography-body-bold {\n    font-size: 14px;\n    line-height: 21px;\n  }\n\n  .typography-body {\n    font-size: 14px;\n    line-height: 21px;\n  }\n\n  .typography-body-small-bold {\n    font-size: 12px;\n    line-height: 18px;\n  }\n\n  .typography-body-small {\n    font-size: 12px;\n    line-height: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
